<lib-page-container [title]="title" [loading]="screen.isLoading()" [version]="appVersion.version"
  [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button (buttonClick)="onBack()" tooltip="Back to Advertiser" icon="arrow_back"> Back</lib-button>
    <lib-button (buttonClick)="onRefresh()" tooltip="Refresh" icon="replay"> Refresh</lib-button>
  </div>
  <div lib-page-body>
    <div class="settings-container">
      <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)"
        mat-stretch-tabs="false" class="compact-tabs" mat-align-tabs="start">
        <mat-tab label="General Information">
          <div class="tab-content">
            <app-advertiser-general-info [advertiser]="advertiser"></app-advertiser-general-info>
          </div>
        </mat-tab>

        <mat-tab label="Organizations">
          <div class="tab-content">
            <app-advertiser-organizations [advertiser]="advertiser"></app-advertiser-organizations>
          </div>
        </mat-tab>

        <mat-tab label="Campaigns">
          <div class="tab-content">
            <app-advertiser-linked-campaigns [advertiser]="advertiser"></app-advertiser-linked-campaigns>
          </div>
        </mat-tab>

        <mat-tab label="User Profile">
          <div class="tab-content">
            <app-advertiser-consumer-profile-config [advertiser]="advertiser"></app-advertiser-consumer-profile-config>
          </div>
        </mat-tab>

        @if (!isBrandAdmin) {
        <mat-tab label="Data Connection">
          <div class="tab-content">
            <app-advertiser-consumer-data-connection
              [advertiser]="advertiser"></app-advertiser-consumer-data-connection>
          </div>
        </mat-tab>
        <mat-tab label="Users">
          <div class="tab-content">
            <app-advertiser-users [advertiser]="advertiser"></app-advertiser-users>
          </div>
        </mat-tab>
        <mat-tab label="Openers">
          <div class="tab-content">
            <app-advertiser-openers [advertiser]="advertiser"></app-advertiser-openers>
          </div>
        </mat-tab>
        <mat-tab label="Outbound Events">
          <div class="tab-content">
            <app-advertiser-outbound-events [advertiser]="advertiser"></app-advertiser-outbound-events>
          </div>
        </mat-tab>
        <mat-tab label="Login Options">
          <div class="tab-content">
            <app-advertiser-login-options [advertiser]="advertiser"></app-advertiser-login-options>
          </div>
        </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</lib-page-container>